import React from "react";
import "./Commerce.css";

const Commerce = () => {
  const commerceProducts = [
    {
      id: 1,
      name: "E-Commerce Store Platform",
      description: "Complete solution for building and managing your online store with powerful selling features.",
      features: [
        "Customizable product catalog",
        "Secure checkout process",
        "Multiple payment gateways",
        "Order and inventory management",
        "Mobile-responsive design",
        "SEO optimization tools"
      ],
      expectations: [
        "24/7 online sales channel",
        "Global customer reach",
        "Reduced operational costs",
        "Detailed sales analytics"
      ],
      customization: [
        "Branded storefront design",
        "Custom product variants",
        "Subscription products",
        "API integrations"
      ]
    },
    {
      id: 2,
      name: "Multi-Vendor Marketplace",
      description: "Platform enabling multiple sellers to offer products/services in a unified marketplace.",
      features: [
        "Vendor registration and management",
        "Commission system",
        "Product listing management",
        "Order routing and fulfillment",
        "Dispute resolution",
        "Vendor analytics dashboard"
      ],
      expectations: [
        "Rapid marketplace launch",
        "Scalable vendor network",
        "Revenue sharing model",
        "Diverse product offerings"
      ],
      customization: [
        "Niche-specific marketplace",
        "Custom commission structures",
        "Vendor subscription tiers",
        "Advanced vendor tools"
      ]
    },
    {
      id: 3,
      name: "Restaurant Ordering System",
      description: "Digital solution for restaurants to manage online orders and streamline operations.",
      features: [
        "Online menu management",
        "Table reservations",
        "Online payment processing",
        "Kitchen display system",
        "Delivery integration",
        "Customer loyalty programs"
      ],
      expectations: [
        "Increased order volume",
        "Reduced order errors",
        "Improved customer experience",
        "Operational efficiency"
      ],
      customization: [
        "Branded mobile apps",
        "Custom menu configurations",
        "Integration with POS systems",
        "Multi-location support"
      ]
    },
    {
      id: 4,
      name: "Grocery/Local Delivery App",
      description: "On-demand platform for grocery shopping and local deliveries.",
      features: [
        "Product catalog with categories",
        "Shopping cart and checkout",
        "Real-time delivery tracking",
        "Multiple payment options",
        "Inventory management",
        "Promotions and discounts"
      ],
      expectations: [
        "Faster order fulfillment",
        "Increased customer convenience",
        "Reduced operational costs",
        "Local business support"
      ],
      customization: [
        "Geo-fencing capabilities",
        "Subscription models",
        "Real-time inventory sync",
        "Multi-store management"
      ]
    },
    {
      id: 5,
      name: "Salon/Beauty Spa Booking",
      description: "Management system for beauty and wellness service providers.",
      features: [
        "Online appointment scheduling",
        "Service and staff management",
        "Client database",
        "Mobile check-in",
        "Payment processing",
        "Marketing automation"
      ],
      expectations: [
        "Reduced no-shows",
        "Improved client retention",
        "Increased bookings",
        "Staff productivity"
      ],
      customization: [
        "Branded client app",
        "Membership programs",
        "Product sales integration",
        "Custom service packages"
      ]
    },
    {
      id: 6,
      name: "Real Estate Listings Portal",
      description: "Comprehensive platform for property listings and real estate transactions.",
      features: [
        "Property listing management",
        "Advanced search filters",
        "Virtual tours",
        "Lead capture forms",
        "Agent profiles",
        "Market analytics"
      ],
      expectations: [
        "Increased property visibility",
        "Higher quality leads",
        "Streamlined transactions",
        "Market insights"
      ],
      customization: [
        "Location-specific portals",
        "CRM integration",
        "Mortgage calculators",
        "AI-powered recommendations"
      ]
    },
    {
      id: 7,
      name: "Car Pooling / Ride-Sharing App",
      description: "Platform connecting drivers with passengers for shared rides and commutes.",
      features: [
        "Ride matching algorithm",
        "Route optimization",
        "Fare calculation",
        "Rating and review system",
        "Real-time tracking",
        "Safety features"
      ],
      expectations: [
        "Reduced transportation costs",
        "Community building",
        "Convenient scheduling",
        "Eco-friendly alternative"
      ],
      customization: [
        "Corporate carpool programs",
        "School-specific solutions",
        "Event-based pooling",
        "API integrations"
      ]
    }
  ];

  return (
    <div className="commerce-container">
      <div className="commerce-header">
        <h1>Commerce & Retail Solutions</h1>
        <p className="subtitle">Powerful digital platforms to transform your retail and service business operations</p>
      </div>

      <div className="commerce-grid">
        {commerceProducts.map((product) => (
          <div key={product.id} className="commerce-card">
            <div className="commerce-card-header">
              <h2>{product.name}</h2>
              <p className="commerce-card-description">{product.description}</p>
            </div>

            <div className="commerce-card-details">
              <div className="commerce-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="commerce-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="commerce-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/*
<div className="commerce-card-footer">
  <button className="commerce-demo-button">Request Demo</button>
</div>
*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Commerce;